import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Header from "./Header/Header";
import Menu from "./Menu/Menu";
import { Container, ComponentContainer, BodyContainer } from "./default.styles";
import { create } from "jss";
import rtl from "jss-rtl";
import {
  StylesProvider,
  jssPreset,
  ThemeProvider,
  createTheme ,
} from "@material-ui/core/styles";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const ltrTheme = createTheme({ direction: "ltr" });
const rtlTheme = createTheme({ direction: "rtl" });
const DefaultLayout = ({ children }) => {
  const { t, i18n } = useTranslation("common");
  const [isCalendarpPage, setIsCalendarpPage] = useState(false)
  const [isFoldMenu, setIsFoldMenu] = useState(true)
  useEffect(() => {
    setIsCalendarpPage(window.location.href.includes('calendar'))
  },
  [window.location.href]);
  return (
    <Container>
      {!isCalendarpPage && <Header setIsFold={setIsFoldMenu} isFold={isFoldMenu} />}
      <BodyContainer isRtl={i18n.language === "he"}>
        {!isCalendarpPage && <Menu isCalendarpPage={isCalendarpPage} isFoldMenu={isFoldMenu} />}
        <StylesProvider jss={jss}>
          <ThemeProvider theme={i18n.language === "he" ? rtlTheme : ltrTheme}>
            {/* <ComponentContainer isOpenMenu={isOpenMenu && isCalendarpPage} isCalendarpPage={isCalendarpPage}>{children}</ComponentContainer> */}
            <ComponentContainer isCalendarpPage={isCalendarpPage}>{children}</ComponentContainer>
          </ThemeProvider>
        </StylesProvider>
      </BodyContainer>
    </Container>
  );
};

DefaultLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

export default DefaultLayout;
